import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as appActions from "../actions/appactions";
import * as menuConstants from "../constants/menuConstants";
import * as appConstants from "../overrides/appconstants";
import * as sharedConstants from "../constants/sharedContants";
import securityService from "../services/securityservice";

export default function SideNav() {
    const securityState = useSelector((state) => state.securityReducer);
    let navigate = useNavigate();

    const handleModuleOpen = (menuId, url, e) => {
        e.preventDefault();
        if (appConstants.SYSTEM_ID === 1) {
            window.location.href = securityService.getSystemUrl(securityState.userSession.menus, menuId) + url;
        } else {
            navigate('/' + url);
        }
    };
    function renderDynamicMenu1() {
        let modules = null;
        let systemMenu = null;
        let pages = null;
        let userSession = securityState.userSession;
        if (userSession == null) {
            return <div></div>;
        }
        let userMenu = userSession.menus;
        return (
            <>
                {(systemMenu = userMenu.filter(
                    (p) => p.menuType === menuConstants.MENU_TYPE_SYSTEM
                    &&  (
                        appConstants.SYSTEM_ID==sharedConstants.SYSTEM_IDS.SSO
                        ||
                        p.menuId==appConstants.SYSTEM_MENU_ID
                    )
                )) &&
                    systemMenu.map((sys, index) => (
                        <>
                            <a data-bs-toggle="collapse"
                                href={`#sys-${sys.menuId}`}
                                aria-expanded="false"
                                aria-controls={`sys-${sys.menuId}`}
                                class="side-nav-link"
                                key={sys.menuId}>

                                <i class="uil-folder-plus"></i>
                                 <span> {sys.displayName} </span>
                                <span class="menu-arrow"></span>
                            </a>
                            <div class="collapse" id={`sys-${sys.menuId}`}>
                                <ul class="side-nav-second-level">
                                    <li class="side-nav-item">
                                        {(modules = userMenu.filter(
                                            (p) =>
                                                p.menuType === menuConstants.MENU_TYPE_MODULE &&
                                                p.parentMenuId === sys.menuId
                                        )) &&
                                            modules.map((mod, index) => (
                                                <>
                                                    <a data-bs-toggle="collapse"
                                                        href={`#mod-${mod.menuId}`}
                                                        aria-expanded="false"
                                                        aria-controls={`mod-${mod.menuId}`}
                                                    >
                                                        <span> {mod.displayName} </span>
                                                        <span class="menu-arrow"></span>
                                                    </a>
                                                    <div class="collapse" id={`mod-${mod.menuId}`}>
                                                        <ul class="side-nav-third-level">
                                                            {(pages = userMenu.filter(
                                                                (p) =>
                                                                    p.menuType === menuConstants.MENU_TYPE_PAGE &&
                                                                    p.parentMenuId === mod.menuId
                                                            )) &&
                                                                pages.sort((p1, p2) => (p1.sequenceNo < p2.sequenceNo ) ? -1 : 1).map((page) => (
                                                                    <li key={page.menuId}>
                                                                        <a
                                                                            key={page.menuId}
                                                                            href="javascript: void(0);"
                                                                            onClick={(e) => handleModuleOpen(page.menuId, page.url, e)}
                                                                        >
                                                                            {page.displayName}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                    </div>
                                                </>
                                            ))

                                        }
                                    </li>
                                </ul>
                            </div>
                        </>
                    ))
                }
            </>
        )
    }

    function renderDynamicMenu() {
        let modules = null;
        let systemMenu = null;
        let pages = null;
        let userSession = securityState.userSession;
        if (userSession == null) {
            return <div></div>;
        }
        let userMenu = userSession.menus;
        return (
            <>
                <li class="side-nav-item">
                    <a data-bs-toggle="collapse" href="#sidebarMultiLevel" aria-expanded="false" aria-controls="sidebarMultiLevel" class="side-nav-link">
                        <i class="uil-folder-plus"></i>
                        <span> Multi Level </span>
                        <span class="menu-arrow"></span>
                    </a>
                    <div class="collapse" id="sidebarMultiLevel">
                        <ul class="side-nav-second-level">
                            <li class="side-nav-item">
                                <a data-bs-toggle="collapse" href="#sidebarSecondLevel" aria-expanded="false" aria-controls="sidebarSecondLevel">
                                    <span> Second Level </span>
                                    <span class="menu-arrow"></span>
                                </a>
                                <div class="collapse" id="sidebarSecondLevel">
                                    <ul class="side-nav-third-level">
                                        <li>
                                            <a href="javascript: void(0);">Item 1</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0);">Item 2</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </>
        );
    }

    return (
        <div className="leftside-menu leftside-menu-detached">
            <div className="leftbar-user">
                <a href="javascript: void(0);">
                    <img
                        src="content/theme/assets/images/help-icon.svg"
                        height="90"
                        alt="Helper Icon Image"
                    />
                </a>
            </div>
            <ul className="side-nav">
                <li className="side-nav-title"></li>
                {renderDynamicMenu1()}
            </ul>
            <div className="clearfix"></div>
        </div>
    );
}
